import 'whatwg-fetch';

const charsToReplace = /[^\w]/g;

/**
 * this function can be used to instantiate a local variable in an action file that can represent the action types that are commonly used with making an api call
 *
 * the types of actions that are supported by this are as follows:
 * - begin: this is an action triggers just before the api call would be made
 * - success: this is an action that triggers if the api call returns successfully
 * - failure: this is an action that triggers if the api call returns with a failure status
 * @param {string} namespace This string corresponds to the namespace associated with the actions file that calls this
 * @param {string} actionPrefix This string represents provides a way to distinguish between multiple different fetchActions in the same namespace
 * @returns a structure that contains the action type names and an actionTypes object has the action type names
 *          associated with variable names that are in standard Participant Portal format for the actionTypes structure
 */
export const fetchActions = (namespace, actionPrefix) => {
  const beginValue = `${namespace}.${actionPrefix}-begin`;
  const successValue = `${namespace}.${actionPrefix}-success`;
  const failureValue = `${namespace}.${actionPrefix}-failure`;

  const beginName = `${actionPrefix}-begin`.replace(charsToReplace, "_").toUpperCase();
  const successName = `${actionPrefix}-success`.replace(charsToReplace, "_").toUpperCase();
  const failureName = `${actionPrefix}-failure`.replace(charsToReplace, "_").toUpperCase();

  return {
    begin: beginValue,
    success: successValue,
    failure: failureValue,
    actionTypes: {
      [beginName]: beginValue,
      [successName]: successValue,
      [failureName]: failureValue,
    }
  }
}
